import request from '@/utils/request'


// 查询用户余额充值记录列表
export function listUserBalanceRecord(query) {
  return request({
    url: '/biz/admin/user/user/balance/record/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询用户余额充值记录分页
export function pageUserBalanceRecord(query) {
  return request({
    url: '/biz/admin/user/user/balance/record/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询用户余额充值记录详细
export function getUserBalanceRecord(data) {
  return request({
    url: '/biz/admin/user/user/balance/record/detail',
    method: 'get',
    params: data
  })
}

